import { mbaHighlights } from "./constant";
import "../../shared/styles/index.css";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { CreateStudentEnquirey } from "../../api/Global";

const Institute_Highlights = () => {
  const [showMoreContent, setShowMoreContent] = useState(false);
 const navigate = useNavigate();
  const closeModal = () => setShowModal(false);
  const openModal = () => setShowModal(true);

  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [city, setCity] = useState("");
  const [course, setCourse] = useState("");
  const [mathAnswer, setMathAnswer] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showModal, setShowModal] = useState(false);

  const [nameError, setNameError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [cityError, setCityError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [courseError, setCourseError] = useState("");
  const [sumAnswerError, setsumAnswerError] = useState("");

  const HandleSubmit = async (e) => {
    e.preventDefault();

    setNameError("");
    setMobileError("");
    setCityError("");
    setEmailError("");
    setCourseError("");
    setsumAnswerError("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const indianMobileRegex = /^[6-9]\d{9}$/;

    if (!name.trim()) return setNameError("Name is required!");

    if (!email.trim()) return setEmailError("Email is required!");
    if (!emailRegex.test(email.trim()))
      return setEmailError(
        "Please provide a correct email, invalid email format!"
      );

    if (!mobile.trim()) return setMobileError("Mobile number is required!");
    if (!indianMobileRegex.test(mobile.trim()))
      return setMobileError("Invalid mobile number format");
    if (!city.trim()) return setCityError("City is required!");

    if (!course.trim()) return setCourseError("Course is required!");

    if (!mathAnswer.trim()) return setsumAnswerError("Please add the sum!");
    if (mathAnswer.toString() !== "14")
      return setsumAnswerError("Please add and put the correct value");
    const data = {
      name,
      email,
      mobile,
      email,
      city,
      course,
      mathAnswer,
    };
    try {
      const response = await CreateStudentEnquirey(data);

      if (response?.data?.status == true) {
        navigate("/Thank_You");
        setName("");
        setEmail("");
        setMobile("");
        setCity("");
        setCourse("");
        setMathAnswer("");
        setShow(false);
      }
    } catch (error) {
      console.error("error", error);
    }
  };


  const handleShowContent = () => {
    setShowMoreContent(!showMoreContent);
  };

  return (
    <div className="institute-highlight-container">
      
      <Modal
        size="lg"
        className="asmission_enquiry"
        show={showModal}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="text-center"
            style={{
              textAlign: "center",
              width: "100%",
              color: "#007bff",
            }}
          >
            Admissions Enquiry Form
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="bg-white p-2 p-lg-5">
            <div className="modlaPopup">
              <div className="elementor-widget-container">
                <form className="wpcf7-form">
                  <div className="form-group mb-3">
                    <label>Your Name</label>
                    <input
                      className="form-control"
                      placeholder="Name"
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      name="name"
                      value={name}
                    />
                    {nameError && <p className="text-danger">{nameError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Your Email</label>
                    <input
                      className="form-control"
                      placeholder="Email ID"
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      name="email"
                      value={email}
                    />
                    {emailError && <p className="text-danger">{emailError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Mobile Number</label>
                    <input
                      className="form-control"
                      placeholder="Phone"
                      onChange={(e) => setMobile(e.target.value)}
                      type="number"
                      name="mobile"
                      value={mobile}
                    />
                    {mobileError && (
                      <p className="text-danger">{mobileError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>City</label>
                    <input
                      className="form-control"
                      placeholder="City"
                      onChange={(e) => setCity(e.target.value)}
                      type="text"
                      name="city"
                      value={city}
                    />
                    {cityError && <p className="text-danger">{cityError}</p>}
                  </div>

                  <div className="form-group mb-3">
                    <label>Course</label>
                    <select
                      className="form-control"
                      required
                      name="course"
                      value={course}
                      onChange={(e) => setCourse(e.target.value)}
                    >
                      <option value="">Please select Any Course</option>
                      <option value="B.Tech. Courses[CS,IT,AI & DS,CSIT]">
                        Engineering Courses [CS, IT, AI & DS, CSIT]
                      </option>
                      <option value="B.Tech. Course [EC]">
                        Engineering Course [Electronics & Comm. Engg.]
                      </option>
                      <option value="B.Tech. Course [ME]">
                        Engineering Course [Mechanical Engineering]
                      </option>
                      <option value="B.Tech. Course [Civil Engg.]">
                        Engineering Course [Civil Engineering]
                      </option>
                      <option value="Pharmacy Courses[B.Pharm, D.Pharm]">
                        Pharmacy Courses [B.Pharm, D.Pharm]
                      </option>
                      <option value="Pharmacy Course[M.Pharm]">
                        Pharmacy Course [M.Pharm]
                      </option>
                      <option value="Management Courses[MBA(FT,MM,FA)]">
                        Management Courses [MBA(FT,MM,FA)]
                      </option>
                      <option value="Professional Course [BBA]">
                        Professional Courses [BBA]
                      </option>
                      <option value="Professional Course[BCA]">
                        Professional Courses [BCA]
                      </option>
                      <option value="Professional Course[B.Com]">
                        Professional Courses [B.Com]
                      </option>
                      <option value="Law Courses(LLB Hons, BA LLB Hons, BBA LLB Hons)">
                        Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]
                      </option>
                      <option value="MCA Course">MCA Course</option>
                    </select>
                    {courseError && (
                      <p className="text-danger">{courseError}</p>
                    )}
                  </div>

                  <div className="form-group mb-3">
                    <label>What is nine plus five?</label>
                    <input
                      className="form-control"
                      placeholder="Answer"
                      onChange={(e) => setMathAnswer(e.target.value)}
                      type="text"
                      name="mathAnswer"
                      value={mathAnswer}
                    />
                    {sumAnswerError && (
                      <p className="text-danger">{sumAnswerError}</p>
                    )}
                  </div>
                  {/* 
                  <div className="form-group">
                    <div className="form-submit">
                      <button  type="button" onClick={HandleSubmit} className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div> */}

                  <div className="form-group mb-3 text-center">
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      onClick={HandleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <div className="institute-highlight-first-container">
        <h2 className="section-title-h2">
          Why CDGI is Among the Best MBA Colleges in Indore
        </h2>
        <p className="section-description">
          CDGI's MBA program is designed not just to educate but to empower. We
          are one of the few MBA colleges in Indore that seamlessly blend
          classroom learning with experiential training, corporate mentoring,
          and placement-focused modules.
        </p>
      </div>

      {showMoreContent && (
        <>
          <div className="institute-highlight-second-container">
            <h3 className="subsection-title-h3">
              Key Highlights of MBA at CDGI
            </h3>
            <div className="mba-highlights-list">
              {mbaHighlights.map((highlight, ind) => (
                <p key={ind} className="highlight-item">
                  • {highlight}
                </p>
              ))}
            </div>
          </div>

          <div className="vision-container">
            <h4 className="vision-title-h4">
              Our Vision for Management Education
            </h4>
            <p className="vision-description">
              CDGI aims to nurture ethical business professionals who drive
              sustainable growth in a global environment. Our vision is to
              become one of the top MBA colleges in Indore by producing leaders
              who are innovative, responsible, and business-savvy.
            </p>
          </div>

          <div className="mba-specializations-container">
            <h2 className="section-title-h2">MBA Specializations at CDGI</h2>

            <div className="marketing-management-specialization">
              <Link to="/Overview/66e950f99fd5e8df87e79620/mba-marketing-management-2years">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  MBA in Marketing Management
                </h3>
              </Link>
              <p className="specialization-description">
                The MBA in Marketing Management program is designed to develop
                strong analytical and strategic thinking skills. Through
                immersive modules on consumer behavior, digital marketing,
                branding, and marketing analytics, students gain a deep
                understanding of modern marketing trends.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Highlights:</p>
                <p>• Consumer Behavior & Market Research</p>
                <p>• Strategic Brand Management</p>
                <p>• Digital Marketing Tools</p>
                <p>• Advertising & Media Planning</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>
                <p> • Brand Manager</p>
                <p> • Digital Marketing Analyst</p>
                <p> • Marketing Consultant</p>
                <p> • Product Manager</p>
              </div>
            </div>

            <div className="financial-administration-specialization">
              <Link to="/Overview/66e956629fd5e8df87e796f8/mba-financial-administration-2years">
                <h3 className="subsection-title-h3 text-hover-blue-underline">
                  MBA in Financial Administration
                </h3>
              </Link>

              <p className="specialization-description">
                The MBA in Financial Administration equips students with
                in-depth knowledge of financial systems, risk management,
                investment analysis, and global finance trends. With hands-on
                training in tools like SAP, Tally, and Excel Analytics, students
                graduate job-ready.
              </p>

              <div className="course-highlights">
                <p className="highlight-heading">Course Highlights:</p>
                <p>• Corporate Finance & Investment Planning</p>
                <p>• Risk & Portfolio Management</p>
                <p>• Financial Modeling & Reporting</p>
                <p>• Mergers & Acquisitions</p>
              </div>

              <div className="career-paths">
                <p className="highlight-heading">Career Paths:</p>
                <p>• Financial Analyst</p>
                <p>• Investment Banker</p>
                <p>• Credit Risk Manager</p>
                <p>• Corporate Treasurer</p>
              </div>
            </div>
          </div>

          <div className="placements-container">
            <h2 className="section-title-h2">
              CDGI Placements for MBA Graduates
            </h2>
            <p className="section-description">
              Our strong placement cell makes CDGI one of the most reliable MBA
              colleges in Indore for job readiness and career success. From
              grooming sessions to placement drives, we prepare students at
              every stage.
            </p>

            <div className="top-recruiters">
              <p className="highlight-heading">Top Recruiters:</p>
              <p> • TCS</p>
              <p> • ICICI Bank</p>
              <p> • HDFC Life</p>
              <p> • Infosys</p>
              <p> • Kotak Mahindra Bank</p>
              <p> • Wipro</p>
              <p> • Deloitte</p>
            </div>

            <div className="placement-prep">
              <p className="highlight-heading">
                Placement Preparation Includes:
              </p>
              <p>• Resume Building Workshops</p>
              <p>• Mock Interviews with HR Experts</p>
              <p>• Aptitude & GD Training</p>
              <p> • Internship & Final Placement Support</p>
            </div>
          </div>

          <div className="student-life-container">
            <h2 className="section-title-h2">
              Student Life at CDGI – Beyond Academics
            </h2>
            <p className="section-description">
              CDGI offers more than academics. Our campus is designed to develop
              holistic leaders. MBA students can join clubs, participate in
              national-level competitions, organize corporate events, and enjoy
              a thriving hostel life.
            </p>

            <div className="campus-facilities">
              <p className="campus-highlight">Campus Facilities:</p>
              <p>• Wi-Fi Enabled Hostels</p>
              <p>• Library with 20,000+ Volumes</p>
              <p>• Entrepreneurship Cell & Innovation Labs</p>
              <p>• Sports Complex & Gym</p>
              <p>• Auditoriums & Seminar Halls</p>
            </div>
          </div>

          <div className="why-cdgi-standout-container">
            <h2 className="section-title-h2">
              What Makes CDGI Stand Out Among MBA Colleges in Indore
            </h2>

            <p>
              • Academic Excellence with Practical Exposure Our pedagogy
              emphasizes real-world business situations. Case studies,
              simulations, and project-based learning ensure that students think
              like decision-makers.
            </p>
            <p>
              • Faculty with Industry Experience Our faculty comprises PhD
              holders, ex-industry executives, and certified trainers who bring
              invaluable insights to the classroom.
            </p>
            <p>
              • Strategic Location in Indore Situated in one of India’s
              fastest-growing education hubs, CDGI offers unmatched access to
              industrial zones, start-ups, and financial institutions.
            </p>
          </div>

          <div className="admission-process-container">
            <h2 className="section-title-h2">
              Admission Process at CDGI for MBA 2025-26
            </h2>

            <div className="eligibility-criteria">
              <h4 className="subsection-title-h4">Eligibility Criteria:</h4>
              <p>• Bachelor’s degree with at least 50% marks (45% for SC/ST)</p>
              <p>
                • Valid score in CMAT / MAT / CAT or state-level entrance exams
              </p>
            </div>

            <div className="steps-to-apply">
              <h4 className="subsection-title-h4">Steps to Apply:</h4>
              <p>
                • Click on{" "}
                  <span
                    className="text-hover-blue-underline"
                    style={{
                      fontSize: "17px",
                      fontWeight: "500",
                    }}
                    onClick={openModal}
                  >
                    {" "}
                    Apply Now
                  </span>
                for MBA Program
              </p>
            </div>
          </div>
        </>
      )}

      <div>
        <button
          style={{
            all: "unset",
            textAlign: "center",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "0px",
            paddingBottom: "0px",
            borderRadius: "3px",
            backgroundColor: "#004b9c",
            color: "white",
            cursor: "pointer",
            marginTop: "10px",
          }}
          onClick={handleShowContent}
        >
          {showMoreContent ? "Read Less" : "Read More"}
        </button>
      </div>
    </div>
  );
};

export default Institute_Highlights;
